// src/components/ui/button.jsx
import * as React from "react";

const VARIANTS = {
  default: "bg-primary text-textAccent hover:bg-primary/90 focus:ring-primary",
  outline:
    "border border-borderDefault bg-transparent text-textPrimary hover:bg-secondary/20 focus:ring-primary",
  destructive:
    "bg-destructive text-textAccent hover:bg-destructiveHover focus:ring-destructive",
  secondary: "bg-secondary text-textPrimary hover:bg-secondaryHover focus:ring-secondary",
  success: "bg-success text-textAccent hover:bg-successHover focus:ring-success",
  successHover: "bg-successHover text-textAccent",
  destructiveHover: "bg-destructiveHover text-textAccent",
  // Ghost: no background by default; inherits text color from className
  ghost: "bg-transparent text-textPrimary hover:bg-secondary/10 focus:ring-primary",
};

const SIZES = {
  sm: "px-2 py-1 text-sm",
  md: "px-4 py-2 text-sm",
  lg: "px-6 py-3 text-base",
};

/**
 * Simple Button component with `variant` and `size` props.
 */
export const Button = React.forwardRef(
  ({ variant = "default", size = "md", className = "", ...props }, ref) => {
    const variantClasses = VARIANTS[variant] || VARIANTS.default;
    const sizeClasses = SIZES[size] || SIZES.md;
    return (
      <button
        ref={ref}
        className={
          [
            "inline-flex items-center justify-center",
            "rounded-lg font-medium transition-colors",
            "focus:outline-none focus:ring-2 focus:ring-offset-2",
            "disabled:opacity-50 disabled:pointer-events-none",
            variantClasses,
            sizeClasses,
            className,
          ].join(" ")
        }
        style={{
          letterSpacing: 'var(--letter-spacing)',
          textTransform: 'var(--text-transform-btn)',
          fontWeight: 'var(--font-weight-medium)',
        }}
        {...props}
      />
    );
  }
);

Button.displayName = "Button";
